// Assessment types for the IT Experts portal

export interface AssessmentOption {
  id: string
  option_text: string
  option_code?: string
  display_order: number
}

export interface AssessmentQuestion {
  id: string
  question_type: 'single_choice' | 'multiple_choice' | 'code_review'
  content: string
  code_snippet?: string
  code_language?: string
  time_limit_seconds: number
  options: AssessmentOption[]
  sequence_number: number
}

export interface AssessmentProgress {
  questions_answered: number
  estimated_level: string
  progress_percent: number
  time_elapsed_seconds: number
  time_remaining_seconds: number
}

export interface AssessmentResult {
  level: string
  level_description: string
  percentile: number
  questions_answered: number
  correct_answers: number
  accuracy: number
  duration_seconds: number
}

export interface AssessmentState {
  assessment_id: string
  skill_id: string
  is_complete: boolean
  question?: AssessmentQuestion
  progress: AssessmentProgress
  results?: AssessmentResult
  presented_at?: string
}

export interface AssessmentSummary {
  id: string
  skill_id: string
  skill_name?: string
  status: 'in_progress' | 'completed' | 'timed_out'
  questions_answered: number
  final_level?: string
  percentile?: number
  started_at: string
  completed_at?: string
}

export interface Skill {
  id: string
  name: string
  description?: string
  category: string
  icon?: string
}

// Helper to get level badge color
export function getLevelColor(level: string): string {
  switch (level.toLowerCase()) {
    case 'beginner':
      return 'bg-gray-500'
    case 'intermediate':
      return 'bg-blue-500'
    case 'advanced':
      return 'bg-purple-500'
    case 'expert':
      return 'bg-yellow-500'
    default:
      return 'bg-gray-400'
  }
}

// Format duration from seconds
export function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
}
